import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { m } from 'framer-motion';
import { varHover } from 'src/components/animate';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import useAuth from 'src/routes/hooks/use-auth';
import { PRIMARY } from 'src/theme/palette';

export default function AccountPopover() {
  // const { logout, auth } = useAuth();
  const { logout } = useAuth();

  const popover = usePopover();

  return (
    <>
      <Stack direction={'row'} sx={{ width: '100%', justifyContent: 'space-between' }}>
        <Typography sx={{ lineHeight: '50px', fontWeight: '600', fontSize: '15px' }}>
          {' '}
          {/* {auth?.name} */}
          관리자님, 안녕하세요 👋
        </Typography>

        <Box>
          <IconButton
            component={m.button}
            whileTap="tap"
            whileHover="hover"
            variants={varHover(1.05)}
            onClick={popover.onOpen}
            sx={{
              width: 40,
              height: 40,
              background: (theme) => alpha(theme.palette.grey[500], 0.08),
              ...(popover.open && {
                background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.lighter} 100%)`
              })
            }}
          >
            <Avatar
              src={'/static/mock-images/avatars/avatar_default.jpg'}
              // alt={auth?.name ?? undefined}

              sx={{
                fontSize: '14px',
                width: 36,
                height: 36,
                color: PRIMARY.main,
                fontWeight: '700',
                backgroundColor: 'white',
                border: (theme) => `solid 2px ${theme.palette.primary.main}`
              }}
            />
          </IconButton>

          <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
            <Box sx={{ p: 2, pb: 1.5 }}>
              <Typography variant="subtitle2" noWrap>
                {/* {auth?.name} */}
                관리자님
                {/* TODO: 관리자 이름 추가 */}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                {/* {auth?.email} */}
              </Typography>
            </Box>

            <Divider sx={{ borderStyle: 'dashed' }} />

            {/* <Stack sx={{ p: 1 }}> */}
            {/*   {OPTIONS.map((option) => ( */}
            {/*     <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}> */}
            {/*       {option.label} */}
            {/*     </MenuItem> */}
            {/*   ))} */}
            {/* </Stack> */}

            <Divider sx={{ borderStyle: 'dashed' }} />

            <MenuItem onClick={() => logout()} sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}>
              로그아웃
            </MenuItem>
          </CustomPopover>
        </Box>
      </Stack>
    </>
  );
}
